
/*
 * Accordion Landing
 */

$('.js-accordion-faq .accordion-faq__section')
  .not('.accordion-faq__section--current')
  .find('.accordion-faq__body').hide();

$('.js-accordion-faq .js-accordion-faq-btn').on('click', function(event) {
  event.preventDefault();

  $(this)
    .closest('.accordion-faq__head')
    .siblings()
    .stop()
    .slideToggle()
    .closest('.accordion-faq__section')
    .toggleClass('accordion-faq__section--current')
    .siblings()
    .removeClass('accordion-faq__section--current')
    .find('.accordion-faq__body')
    .slideUp();
});

const headerNotice = document.querySelector('.header .header__notice');

if (headerNotice) {
  ['load', 'scroll', 'resize'].forEach((eventName) => {
    window.addEventListener(eventName, (e) => {
      document.documentElement.style.setProperty(
        '--header-notice-height',
        `${headerNotice.offsetHeight}px`,
      );
    });
  });
}
